module.exports = __webpack_public_path__ + "static/media/proj1_img16.4be941ac.jpg";